// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"3aeb5418","226":"debb017b"}[chunkId] + ".chunk.css";
};